@if (form()) {
  <div class="flex-column">
    <div class="flex-row align-center mat-h2 gap-sm">
      Kundenstammdaten
      @for (action of actions(); track action.controlAction) {
        <lib-dynamic-form-action
          [hideLabel]="true"
          [action]="action"
          (callActionFunction)="callActionFunction($event)"
        />
      }
    </div>

    <div class="mat-h3">
      Kundendaten
    </div>
    <mat-divider/>
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.shortName]"
      [formData]="formData.shortName()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.fullName]"
      [formData]="formData.fullName()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.ik]"
      [formData]="formData.ik()"
    />

    <br>

    <div class="mat-h3">
      Kontakt
    </div>
    <mat-divider/>
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.email]"
      [formData]="formData.email()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.phone]"
      [formData]="formData.phone()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.fax]"
      [formData]="formData.fax()"
    />

    <br>

    <div class="mat-h3">
      Adresse
    </div>
    <mat-divider/>

    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.addressName]"
      [formData]="formData.addressName()"
    />

    <div class="flex-row">
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.street]"
        [formData]="formData.street()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.houseNumber]"
        [formData]="formData.houseNumber()"
      />
    </div>

    <div class="flex-row">
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.zip]"
        [formData]="formData.zip()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.city]"
        [formData]="formData.city()"
      />
    </div>

    <br>

    <div class="mat-h3">
      Bankverbindung
    </div>
    <mat-divider/>

    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.bankRecipient]"
      [formData]="formData.bankRecipient()"
    />

    <div class="flex-row">
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.iban]"
        [formData]="formData.iban()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.bic]"
        [formData]="formData.bic()"
      />
    </div>

    <br>

    <div class="mat-h3">
      Sonstige
    </div>
    <mat-divider/>

    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.provider]"
      [formData]="formData.provider()"
    />

    <br>

    <div class="mat-h3">
      Logo
    </div>
    <mat-divider/>

    <app-upload-wrapper
      style="padding-top: 0.5rem"
      [formControl]="form().controls[EFormKeys.logo]"
      readAs="Image"
      [maxSize]="10000000"
      [accept]="'.jpg, .png, .webp'"
      (changed)="onLogoChanged($event)"
    />

    <br>

    <div class="mat-h3">
      Unternehmenskennung
    </div>
    <mat-divider/>
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.taxpayersAccountNumber]"
      [formData]="formData.taxpayersAccountNumber()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.hraEntry]"
      [formData]="formData.hraEntry()"
    />
    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.legalStatus]"
      [formData]="formData.legalStatus()"
    />
  </div>

} @else {
  <mat-progress-bar
    mode="indeterminate"
  ></mat-progress-bar>
}
<input
  #fileUpload
  style="display: none"
  type="file"
  accept=".json"
  (change)="uploadJson($event).subscribe()"
/>
